<script setup lang="ts">
import {computed} from 'vue';
import {useStore} from '../store';
import {IndoorOutdoor} from '../types';

const store = useStore();

const options = computed(() => [
    {value: IndoorOutdoor.Outdoor, label: 'Outdoor'},
    {value: IndoorOutdoor.Indoor, label: 'Indoor'},
]);
</script>

<template>
    <div class="visualiser-controls-toggle">
        <div
            v-for="{value, label} in options"
            :class="['visualiser-controls-toggle-option', store.indoorOutdoor === value && 'active']"
            @click="store.indoorOutdoor = value"
        >
            {{ label }}
        </div>
    </div>
</template>
